import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface State {
    selectedAreaCode: string
}

interface Actions {
    setSelectedAreaCode: (areaCode: State['selectedAreaCode']) => void
    clear: () => void
}

export const useAreaStore = create<State & Actions>()(
    persist(
        (set) => ({
            selectedAreaCode: 'all',
            setSelectedAreaCode: (areaCode) => set({ selectedAreaCode: areaCode }),
            clear: () =>
                set({
                    selectedAreaCode: 'all',
                }),
        }),
        {
            name: 'area-storage',
        }
    )
)
